module.exports = __webpack_public_path__ + "img/footer-logos.2e447335.png";